import React from "react";
import useMetaTags from "../../hooks/useMetaTags"; // Adjust path based on your project structure

const NaturalPeriodPainManagement = () => {
  useMetaTags({
    title: "Natural Period Pain Management: How Organic Products Help",
    description: "Discover how organic menstrual products can help reduce period pain naturally. Say goodbye to irritation and discomfort with chemical-free solutions.",
    keywords: "period pain relief, natural period pain management, organic menstrual products, chemical-free pads, reduce period cramps",
    author: "Organic Pads",
    robots: "index, follow",
    canonical: "/natural-period-pain-management",
    ogTitle: "Natural Period Pain Management: How Organic Products Help",
    ogDescription: "Reduce period pain naturally with organic menstrual products. Learn how chemical-free pads can improve comfort and support your body's natural healing.",
    ogImage: "https://img.freepik.com/free-photo/young-beautiful-woman-red-pajamas-relaxing-bed_141793-47262.jpg?ga=GA1.1.567354764.1736148549&semt=ais_hybrid",
    ogUrl: "https://organicpads.shop/natural-period-pain-management",
    ogType: "article",
    twitterCard: "summary_large_image",
    twitterTitle: "Natural Period Pain Management: How Organic Products Help",
    twitterDescription: "Find relief from period pain with natural, organic menstrual care. Learn how chemical-free pads can improve comfort and reduce irritation.",
    twitterImage: "https://img.freepik.com/free-photo/young-beautiful-woman-red-pajamas-relaxing-bed_141793-47262.jpg?ga=GA1.1.567354764.1736148549&semt=ais_hybrid",
    twitterSite: "@OrganicPads",
    twitterCreator: "@OrganicPads",
  });

  const schemaMarkup = {
    "@context": "https://schema.org",
    "@type": "Article",
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": "/natural-period-pain-management"
    },
    "headline": "Natural Period Pain Management: How Organic Products Help",
    "description": "Discover how organic menstrual products can help reduce period pain naturally. Say goodbye to irritation and discomfort with chemical-free solutions.",
    "image": "https://img.freepik.com/free-photo/young-beautiful-woman-red-pajamas-relaxing-bed_141793-47262.jpg?ga=GA1.1.567354764.1736148549&semt=ais_hybrid",
    "author": {
      "@type": "Organization",
      "name": "Organic Pads",
      "url": "/"
    },
    "publisher": {
      "@type": "Organization",
      "name": "Organic Pads",
      "logo": {
        "@type": "ImageObject",
        "url": "/logo.png"
      }
    },
    "datePublished": "2025-02-24",
    "dateModified": "2025-02-24",
    "keywords": [
      "period pain relief",
      "natural period pain management",
      "organic menstrual products",
      "chemical-free pads",
      "reduce period cramps"
    ]
  }
  

  return (
    <>
    <div className="max-w-4xl mx-auto p-6 text-gray-700">
      <h1 className="text-3xl font-bold text-center text-green-700 mb-6">
        Natural Period Pain Management: How Organic Products Help
      </h1>
      <img
        src="https://img.freepik.com/free-photo/young-beautiful-woman-red-pajamas-relaxing-bed_141793-47262.jpg?ga=GA1.1.567354764.1736148549&semt=ais_hybrid"
        alt="Pain Management"
        className="w-full rounded-lg mb-6"
      />
      <p>
        Period pain can be influenced by the products you use. Organic pads,
        free from irritating chemicals, can help reduce discomfort while
        supporting your body's natural healing processes.
      </p>
      
      <h2 className="text-2xl font-semibold text-green-600 mt-6">Pain Management Benefits</h2>
      <ul className="list-disc list-inside mt-2 space-y-2">
        <li>Reduced chemical irritation</li>
        <li>Better circulation</li>
        <li>Natural material comfort</li>
        <li>Decreased inflammation risk</li>
        <li>Hormonal balance support</li>
      </ul>
      
      <h2 className="text-2xl font-semibold text-green-600 mt-6">How to Manage Period Pain?</h2>
      <p className="mt-2">
        Choose <strong>chemical-free</strong> organic pads alongside natural pain
        management techniques for comprehensive relief.
      </p>
      
      <img
        src="https://plus.unsplash.com/premium-photo-1702598576513-fe7425ebf6bd?w=600"
        alt="Natural Relief"
        className="w-full rounded-lg my-6"
      />
      
      <h2 className="text-xl font-semibold text-green-700 text-center mt-6">
        Final Thoughts
      </h2>
      <p className="text-center mt-2">
        Find natural relief from period pain. <strong>Choose organic for comfort!</strong>
      </p>
    </div>
    
      {/* Schema Markup */}
      <script type="application/ld+json">
        {JSON.stringify(schemaMarkup)}
      </script>
    </>
  );
};

export default NaturalPeriodPainManagement;